__webpack_require__.p = "/MYSTRAS/flipbook/";